// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bhf_a","AdSlotBranding__desktop":"bhf_b","AdSlotBranding__mobile":"bhf_c"};